export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/sahane-logo.080bab27.svg","height":255,"width":512,"blurWidth":0,"blurHeight":0};